// @ts-nocheck
// Auto-migrated from js/mockData.js
// ---------- SDK 版本 ----------
const SDK_VERSIONS = [
  {
    version: "v2.4.0",
    platform: "Android",
    date: "2024-05-10",
    status: "released",
    recommended: true,
    size: "1.2 MB",
    download: "/sdk/easyshare-android-v2.4.0.aar",
    changes: [
      "新增 TikTok 分享渠道",
      "优化归因算法准确率提升 15%",
      "修复 Android 14 兼容性问题",
      "减小 SDK 体积 30%",
    ],
    breaking: false,
  },
  {
    version: "v2.4.0",
    platform: "iOS",
    date: "2024-05-10",
    status: "released",
    recommended: true,
    size: "2.4 MB",
    download: "/sdk/easyshare-ios-v2.4.0.framework",
    changes: [
      "新增 TikTok 分享渠道",
      "适配 iOS 17",
      "优化归因算法",
    ],
    breaking: false,
  },
  {
    version: "v2.3.1",
    platform: "Android",
    date: "2024-04-15",
    status: "released",
    recommended: false,
    size: "1.7 MB",
    changes: ["修复短链回调偶发空指针", "增加 Discord 渠道支持"],
    breaking: false,
  },
  {
    version: "v2.3.0",
    platform: "Unity",
    date: "2024-03-22",
    status: "released",
    recommended: true,
    size: "3.8 MB",
    changes: ["Unity 2022 LTS 支持", "iOS Privacy Manifest 适配"],
    breaking: true,
  },
  {
    version: "v2.5.0-beta",
    platform: "Android",
    date: "2024-05-14",
    status: "testing",
    recommended: false,
    size: "1.3 MB",
    changes: ["重构 Adapter 层支持 UGC Post 接口", "新增 Reddit 渠道"],
    breaking: false,
  },
];

// ---------- SDK 监控 mock（研发工具 / SDK 监控） ----------
const SDK_MONITOR = {
  // 接入 SDK 的版本分布
  version_dist: [
    { version: "v2.4.0", platform: "iOS", count: 32, percent: 64 },
    { version: "v2.4.0", platform: "Android", count: 28, percent: 56 },
    { version: "v2.3.1", platform: "iOS", count: 12, percent: 24 },
    { version: "v2.3.1", platform: "Android", count: 18, percent: 36 },
    { version: "v2.3.0", platform: "Unity", count: 6, percent: 30 },
    { version: "其他旧版", platform: "—", count: 4, percent: 8 },
  ],
  // SDK 调用 Top 接口
  api_calls: [
    { api: "EasyShareSDK.share()", calls: 128456, error_rate: 0.42, p95: 156, status: "normal" },
    { api: "EasyShareSDK.trackEvent()", calls: 856321, error_rate: 0.08, p95: 42, status: "normal" },
    { api: "EasyShareSDK.fetchConfig()", calls: 24532, error_rate: 0.15, p95: 220, status: "normal" },
    { api: "EasyShareSDK.generateShortLink()", calls: 128456, error_rate: 1.85, p95: 380, status: "warning" },
    { api: "EasyShareSDK.handleDeepLink()", calls: 45213, error_rate: 3.21, p95: 95, status: "warning" },
  ],
  // 错误日志（最近）
  errors: [
    { time: "2026-05-18 13:35", platform: "iOS 17.4", sdk: "v2.4.0", code: "DEEP_LINK_FAILED", count: 23, sample: "kingsquest:// 唤起被系统拦截" },
    { time: "2026-05-18 13:30", platform: "Android 14", sdk: "v2.4.0", code: "INTENT_NO_RECEIVER", count: 15, sample: "未找到匹配的 Activity" },
    { time: "2026-05-18 13:25", platform: "iOS 16.x", sdk: "v2.3.1", code: "OG_FETCH_TIMEOUT", count: 8, sample: "FB Crawler 请求超时 5s" },
    { time: "2026-05-18 13:18", platform: "Android 13", sdk: "v2.4.0", code: "WHATSAPP_CACHE_STALE", count: 12, sample: "WhatsApp 显示旧版分享卡片" },
  ],
  // 接入游戏数 / 包体数
  summary: { games: 4, packages: 8, sdk_active: 100, sdk_active_today: 92, error_rate: 1.2 },
};

export { SDK_VERSIONS, SDK_MONITOR };
